import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { IOS_CERTIFICATE_GENERATOR_FAQS } from '../../constants';

@Component({
  selector: 'app-ios-certificate-generator-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './ios-certificate-generator-faq-section.component.html',
  styleUrl: './ios-certificate-generator-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosCertificateGeneratorFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = IOS_CERTIFICATE_GENERATOR_FAQS;
}
